import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import {
  AttachmentUploadStatusEnum,
  VideoUploadAttachment,
} from 'modules/community/types/post-attachment'

interface VideoAttachmentPreviewProps {
  className?: string
  attachment: VideoUploadAttachment
}

const VideoAttachmentPreview = ({
  attachment,
  className,
}: VideoAttachmentPreviewProps): ReactNode => {
  return (
    <div
      className={twMerge(
        'size-full overflow-hidden rounded-lg',
        attachment.status === AttachmentUploadStatusEnum.Uploading && `bg-bg-page`,
        className,
      )}
    >
      <video className="size-full object-cover" key={attachment.id} src={attachment.url} />
    </div>
  )
}

export default VideoAttachmentPreview
